export default __webpack_public_path__ + "static/map-0951a286fcdb5cb8a58dd97467e0e53d.png";